import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-MyTemplate",
  "use": "icon-MyTemplate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-MyTemplate\"><path d=\"M0.00007 393.856h275.712V1024H39.36007a39.36 39.36 0 0 1-39.36-38.4z m1024 0V984.64a39.36 39.36 0 0 1-39.36 39.36H354.43207V393.856zM984.64007 0a39.36 39.36 0 0 1 39.36 39.36v275.712h-1024V39.36A39.296 39.296 0 0 1 38.40007 0z\" fill=\"#00AAA6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol